import {
    activeSellerActions,
    unsoldActions
} from '../../helpers/item-actions-helper-seller';
import {
    activeBuyerActions,
    boughtActions,
    lostActions
} from '../../helpers/item-actions-helper-buyer';
import { PAGE_NAMES } from '../../constants/page';
import { logger } from 'packages/logger';

export const getActionsForItem = (item, listViewType, memberId, pageName) => {
    const secondaryActions = [];
    let primaryAction = null;
    let promotedSecondaryAction = null;

    const checkAndAdd = (action) => {
        try {
            if (!action.isVisible) {
                throw 'Action is not compatible: ' + action.label;
            }
            if (!action.isVisible()) {
                return;
            }
            if (primaryAction === null && action.isPrimaryAction()) {
                // eslint-disable-next-line better-mutation/no-mutation
                primaryAction = action;
            } else if (
                promotedSecondaryAction === null &&
                action.isPromotedSecondaryAction &&
                action.isPromotedSecondaryAction()
            ) {
                // eslint-disable-next-line better-mutation/no-mutation
                promotedSecondaryAction = action;

                // Keep it in secondary actions list for views where promoted secondary is not displayed,
                // and in case user misses promoted secondary button
                secondaryActions.push(action);
            } else {
                secondaryActions.push(action);
            }
        } catch (error) {
            logger(error);
        }
    };

    const resolveActions = (potentialActions) => {
        potentialActions.forEach((actionCreator) => {
            const action = actionCreator();
            checkAndAdd(action);
        });
        return {
            primaryAction,
            secondaryActions,
            promotedSecondaryAction
        };
    };

    let actionsForItem = [];
    switch (pageName) {
        case PAGE_NAMES.BuyerActiveItems:
            actionsForItem = resolveActions(
                activeBuyerActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.BuyerPurchases:
            actionsForItem = resolveActions(
                boughtActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.BuyerItemsLost:
            actionsForItem = resolveActions(lostActions(item, listViewType));
            break;
        case PAGE_NAMES.SellerUnsold:
            actionsForItem = resolveActions(
                unsoldActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.SellerActive:
            actionsForItem = resolveActions(activeSellerActions(item));
            break;
        default:
            throw (
                'Actions for item and pageName ' + pageName + ' is not defined'
            );
    }
    return actionsForItem;
};
